import { CoinType } from "./coin-type";

export class Cost {
    public valueInBits: number;
    public displayString: string;
    public description: string;

    constructor(amount: number, coinType: CoinType) {       
        this.valueInBits = amount * coinType.valueInBits;
        this.displayString = this.simplifyValueInBits(this.valueInBits);
        this.description = this.simplifyValueInBits(this.valueInBits, true);
    }

    public static parse(costString: string) {
        const trimmedString = costString.trim();
        
        const suffix = trimmedString.slice(-1);
        const coinType = CoinType.allCoinTypes.find(ct => ct.abbreviation == suffix);

        if (coinType == undefined) {
            throw Error(`Invalid coin type in ${costString}`);
        }

        const prefix = trimmedString.replace(suffix, '');
        const amount = Number.parseInt(prefix);

        return new Cost(amount, coinType);
    }

    public static sum(costs: Cost[]): Cost {
        const reducer = (accumulator: Cost, currentValue: Cost) => new Cost(accumulator.valueInBits + currentValue.valueInBits, CoinType.bit);
        return costs.reduce(reducer);
    } 

    /**
     * Takes a value in bits and simplifies it. For example, 106 bits becomes 1 gold, 1 copper, 1 bit.
     */
    private simplifyValueInBits(valueInBits: number, showFullDescription = false): string {
        let coinAmountsString = '';

        let coinTypes = [CoinType.gold, CoinType.silver, CoinType.copper, CoinType.bit];
        let residual = valueInBits;
        
        coinTypes.forEach(coinType => {
            if (residual < coinType.valueInBits) {
                return;
            }

            const newResidual = residual % coinType.valueInBits;
            const coinAmount = (residual - newResidual) / coinType.valueInBits; // This should always be an integer
            const coinAmountDescription = showFullDescription ? this.getDescription(coinAmount, coinType) : `${coinAmount}${coinType.abbreviation}`;

            if(coinAmountsString === '') {
                coinAmountsString = coinAmountDescription;
            } else {
                coinAmountsString = coinAmountsString.concat(' ').concat(coinAmountDescription);
            }

            residual = newResidual; 
        });

        return coinAmountsString;
    }

    private getDescription(amount: number, coinType: CoinType): string {
        const coinDescription = amount == 1 ? coinType.fullNameSingular : coinType.fullnamePlural;
        return `${amount} ${coinDescription}`;
    }
}